import { getErrorFromErrorResponse, isErrorResponse } from '@standardnotes/responses';
import { Result } from '@standardnotes/domain-core';
export class RemoveVaultMember {
    constructor(vaultUserServer) {
        this.vaultUserServer = vaultUserServer;
    }
    async execute(params) {
        const response = await this.vaultUserServer.deleteSharedVaultUser({
            sharedVaultUuid: params.sharedVaultUuid,
            userUuid: params.userUuid,
        });
        if (isErrorResponse(response)) {
            return Result.fail(getErrorFromErrorResponse(response).message);
        }
        return Result.ok();
    }
}
